export function useBodyClasses() {
  function addBodyClass(className) {
    if (typeof className === 'string') {
      document.body.classList.add(className);
    } else {
      document.body.classList.add(...className);
    }
  }
  function removeBodyClass(className) {
    if (typeof className === 'string') {
      document.body.classList.remove(className);
    } else {
      document.body.classList.remove(...className);
    }
  }
  function changeBodyClass({ add, remove }) {
    removeBodyClass(remove);
    addBodyClass(add);
  }
  return { addBodyClass, removeBodyClass, changeBodyClass };
}
